import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { fetchGems, getImageUrl } from '../api';
import './Classical.css';

const GEM_TYPES = [
  { name: 'RUBY', color: '#c0392b' },
  { name: 'BLUE SAPPHIRE', color: '#2980b9' },
  { name: 'PADPARADSCHA SAPPHIRE', color: '#e8956d' },
  { name: 'LAVENDER SAPPHIRE', color: '#9b59b6' },
  { name: 'PURPLE SAPPHIRE', color: '#8e44ad' },
  { name: 'WHITE SAPPHIRE', color: '#bdc3c7' },
  { name: 'PINK SAPPHIRE', color: '#e91e8c' },
  { name: 'YELLOW SAPPHIRE', color: '#f39c12' },
  { name: 'STAR SAPPHIRE', color: '#c0392b' },
  { name: 'EMERALD', color: '#27ae60' },
];

export default function Classical() {
  const navigate = useNavigate();
  const [gems, setGems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchGems({ category: 'Classical' })
      .then(data => { setGems(data); setLoading(false); })
      .catch(() => setLoading(false));
  }, []);

  const gemsByType = GEM_TYPES.map(type => {
    const matched = gems.filter(g =>
      g.gemType?.toUpperCase() === type.name ||
      g.name?.toUpperCase().includes(type.name.split(' ')[0])
    );
    return { ...type, items: matched };
  });

  const handleGemClick = (gem) => {
    navigate(`/gem/${gem._id}`);
  };

  return (
    <div className="classical-page">
      <Navbar />
      <div className="classical-hero">
        <div className="classical-hero-bg">
          <div className="classical-watermark">CLASSICAL</div>
        </div>
        <button className="back-btn" onClick={() => navigate(-1)}>‹</button>
        <h1 className="classical-title">Discover the Elegance of Classical Gems</h1>

        {loading ? (
          <div className="loading-grid">
            {GEM_TYPES.map((_, i) => <div key={i} className="skeleton-gem" />)}
          </div>
        ) : (
          <div className="classical-gems-grid">
            {gemsByType.map((type, i) => (
              <div key={i} className="classical-gem-item" onClick={() => {
                if (type.items.length > 0) {
                  navigate(`/gems/${encodeURIComponent(type.name)}`);
                }
              }}>
                <div
                  className="classical-gem-circle"
                  style={{
                    background: type.items[0]?.image
                      ? 'transparent'
                      : `radial-gradient(circle at 35% 35%, ${lighten(type.color)}, ${type.color})`,
                  }}
                >
                  {type.items[0]?.image ? (
                    <img src={getImageUrl(type.items[0].image)} alt={type.name} />
                  ) : (
                    <GemSVG color={type.color} />
                  )}
                </div>
                <p className="classical-gem-name">{type.name}</p>
              </div>
            ))}
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
}

function lighten(hex) {
  const num = parseInt(hex.slice(1), 16);
  const r = Math.min(255, ((num >> 16) & 0xff) + 80);
  const g = Math.min(255, ((num >> 8) & 0xff) + 80);
  const b = Math.min(255, (num & 0xff) + 80);
  return `rgb(${r},${g},${b})`;
}

function GemSVG({ color }) {
  return (
    <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" width="70" height="70">
      <ellipse cx="50" cy="55" rx="38" ry="32" fill={color} opacity="0.9" />
      <polygon points="50,15 80,45 50,75 20,45" fill={color} opacity="0.7" />
      <polygon points="50,15 80,45 50,30" fill="white" opacity="0.25" />
      <ellipse cx="38" cy="32" rx="8" ry="5" fill="white" opacity="0.3" transform="rotate(-30 38 32)" />
    </svg>
  );
}
